<template>
  <div>
    <b-sidebar
      id="mainSidebar"
      ref="sidebar"
      fullheight
      type="is-white"
      mobile="fullwidth"
      :can-cancel="false"
      :open="shouldSidebarBeOpen"
      :expand-on-hover="!isMenuLocked"
      :reduce="!isMenuLocked"
      :class="{ 'hide-text-on-reduce' : !isHovered, 'locked' : isMenuLocked }">
      <div class="creditu-logo-sidebar">
        <a @click="() => { $router.push({ name: 'dashboard' }); }">
          <span class="iso">
            <img
              src="@/ui/assets/img/creditu-iso.svg"
              alt="logo-creditu">
          </span>
          <span class="logo-text">
            <img
              src="@/ui/assets/img/iso-text-creditu.svg"
              alt="logo-creditu">
          </span>
        </a>
        <button
          id="menu-lock"
          :class="{ active: isMenuLocked, 'menu-lock-hovered': isHovered }"
          @click="toggleMenuLock" />
      </div>
      <b-menu class="is-custom-mobile">
        <b-menu-list>
          <span v-if="getlistMenuOptions(undefined).length !== 0">
            <b-menu-item
              v-for="item in getlistMenuOptions(undefined)"
              :id="`${item.route}-link`"
              :key="`
              ${item.name}-
              ${$store.state.currentUser && $store.state.currentUser.user.checkIn && $store.state.currentUser.user.checkIn.is}
              `"
              :data-cy="`${item.route}-link`"
              :icon="item.iconName"
              :label="item.name"
              :active="$route.path.includes(item.path)"
              @click="handleClick(item.route)" />
          </span>
          <span v-if="getlistMenuOptions('consignments').length !== 0">
            <b-menu-item
              id="consignments-parent-link"
              icon="hand-holding-usd"
              :label="$t('backOffice.finance')"
              :active="isAnyChildActive('consignments')"
              :expanded="isAnyChildActive('consignments')">
              <b-menu-item
                v-for="item in getlistMenuOptions('consignments')"
                :id="`${item.route}-link`"
                :key="`
              ${item.name}-
              ${$store.state.currentUser && $store.state.currentUser.user.checkIn && $store.state.currentUser.user.checkIn.is}
              `"
                :data-cy="`${item.route}-link`"
                :icon="item.iconName"
                :label="item.name"
                :active="$route.path.includes(item.path)"
                @click="handleClick(item.route)" />
            </b-menu-item>
          </span>
          <span v-if="getlistMenuOptions('sales').length !== 0">
            <b-menu-item
              id="sales-parent-link"
              icon="file-invoice-dollar"
              :label="$t('backOffice.sales')"
              :active="isAnyChildActive('sales')"
              :expanded="isAnyChildActive('sales')">
              <b-menu-item
                v-for="item in getlistMenuOptions('sales')"
                :id="`${item.route}-link`"
                :key="`
              ${item.name}-
              ${$store.state.currentUser && $store.state.currentUser.user.checkIn && $store.state.currentUser.user.checkIn.is}
              `"
                :data-cy="`${item.route}-link`"
                :icon="item.iconName"
                :label="item.name"
                :active="$route.path.includes(item.path)"
                @click="handleClick(item.route)" />
            </b-menu-item>
          </span>
          <span v-if="getlistMenuOptions('investors').length !== 0">
            <b-menu-item
              id="investors-parent-link"
              icon="briefcase"
              :label="$t('backOffice.investors')"
              :active="isAnyChildActive('investors')"
              :expanded="isAnyChildActive('investors')">
              <b-menu-item
                v-for="item in getlistMenuOptions('investors')"
                :id="`${item.route}-link`"
                :key="`
              ${item.name}-
              ${$store.state.currentUser && $store.state.currentUser.user.checkIn && $store.state.currentUser.user.checkIn.is}
              `"
                :data-cy="`${item.route}-link`"
                :icon="item.iconName"
                :label="item.name"
                :active="$route.path.includes(item.path)"
                @click="handleClick(item.route)" />
            </b-menu-item>
          </span>
          <span v-if="getlistMenuOptions('primary-administration').length !== 0">
            <b-menu-item
              id="primary-administration-parent-link"
              icon="table"
              :label="$t('backOffice.administration')"
              :active="isAnyChildActive('primary-administration')"
              :expanded="isAnyChildActive('primary-administration')">
              <b-menu-item
                v-for="item in getlistMenuOptions('primary-administration')"
                :id="`${item.route}-link`"
                :key="`
              ${item.name}-
              ${$store.state.currentUser && $store.state.currentUser.user.checkIn && $store.state.currentUser.user.checkIn.is}
              `"
                :data-cy="`${item.route}-link`"
                class="sub-menu-item"
                :icon="item.iconName"
                :label="item.name"
                :active="$route.path.includes(item.path)"
                @click="handleClick(item.route)" />
            </b-menu-item>
          </span>
        </b-menu-list>
        <div v-if="screenWidth < 580" class="mt-6">
          <b-menu-list v-if="getlistMenuOptions('header-menu').length !== 0">
            <b-menu-item
              v-for="item in getlistMenuOptions('header-menu')"
              :id="`${item.route}-link`"
              :key="`
              ${item.name}-
              ${$store.state.currentUser && $store.state.currentUser.user.checkIn && $store.state.currentUser.user.checkIn.is}
              `"
              :data-cy="`${item.route}-link`"
              :icon="item.iconName"
              :label="item.name"
              @click="handleClick(item.route)" />
          </b-menu-list>
        </div>
      </b-menu>
      <div class="footer-selector">
        <b-button
          v-if="$store.state.currentUser &&
            ($store.state.currentUser.user.allowedFrontRoutesNames?.includes('settings')
              || $store.state.currentUser.user.allowedUserFeatures?.includes('nav.sidebar.settings')
            )"
          id="settings-link"
          type="is-primary is-light"
          expanded
          icon-left="gear"
          @click="() => { $router.push({ name: 'settings' }); openMenuEmit() }" />
        <b-dropdown
          v-if="haveToShowCountryChange()"
          aria-role="list"
          position="is-top-right"
          size="sm"
          class="mt-0"
          :mobile-modal="false">
          <template #trigger>
            <b-button
              id="change-country"
              type="is-primary is-light"
              icon-left="earth-america"
              expanded>
              <p v-if="$i18n.locale === 'cl'" id="f-select-chile" class="lang-text">Chile</p>
              <p v-if="$i18n.locale === 'br'" id="f-select-brasil" class="lang-text">Brasil</p>
              <p v-if="$i18n.locale === 'pe'" id="f-select-peru" class="lang-text">Perú</p>
            </b-button>
          </template>
          <b-dropdown-item
            v-if="allowCountryForChange('br')"
            id="f-select-brasil"
            mobile-modal="false"
            aria-role="listitem"
            @click="changeCountry('br')">
            <img class="fas fa-2 ml-7 img-country country" src="@/ui/assets/img/brasil.png">
            <span class="ml-1 country">Brasil</span>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="allowCountryForChange('cl')"
            id="f-select-chile"
            mobile-modal="false"
            aria-role="listitem"
            @click="changeCountry('cl')">
            <img class="fas fa-2 ml-7 img-country country" src="@/ui/assets/img/chile.png">
            <span class="ml-1 country">Chile</span>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="allowCountryForChange('pe')"
            id="f-select-peru"
            mobile-modal="false"
            aria-role="listitem"
            @click="changeCountry('pe')">
            <img class="fas fa-2 ml-7 img-country country" src="@/ui/assets/img/peru.png">
            <span class="ml-1 country">Perú</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </b-sidebar>

    <b-modal v-model="isTrustedIdNumbersCardModalActive" scroll="keep">
      <trusted-id-numbers @is-modal-active="isTrustedIdNumbersCardModalActive=$event" />
    </b-modal>
  </div>
</template>
<script>
import { authenticationService } from '@/application/services/api-clients/login-service';
import Roles from '@/domain/rolesEnum';
import userFeatures from '@/ui/mixins/user-features';
import { findUserIdsByEmailOnAllCountries } from '@/application/services/api-clients/users';
import trustedIdNumbers from '../../components/internal/settings/TrustedIdNumbers.vue';

export default {
  components: { trustedIdNumbers },
  props: ['openMenu'],
  data() {
    return {
      isTrustedIdNumbersCardModalActive: false,
      screenWidth: window.innerWidth,
      userIdsByCountry: {
        cl: '',
        br: '',
        pe: ''
      },
      isHovered: false,
      isMenuLocked: false
    };
  },
  computed: {
    shouldSidebarBeOpen() {
      // If the screen width is less than or equal to 910px (an example threshold for mobile screens),
      // use the openMenu prop to control the sidebar's openness.
      if (this.screenWidth <= 910) {
        return this.openMenu;
      }
      // On desktop screens, the sidebar should always be open.
      return true;
    }
  },
  async mounted() {
    // Add an event listener to watch for window resize events
    window.addEventListener('resize', this.updateScreenWidth);
    const { user } = this.$store.state?.currentUser || { user: {} };
    this.userIdsByCountry = user.email && this.haveToShowCountryChange() ? await findUserIdsByEmailOnAllCountries(user.email) : {
      cl: '',
      br: '',
      pe: ''
    };
    this.$refs.sidebar.$el.addEventListener('mouseenter', () => {
      this.handledSidebar(true);
    });
    this.$refs.sidebar.$el.addEventListener('mouseleave', () => {
      this.handledSidebar(false);
    });
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    isAnyChildActive(parentMenu) {
      const salesMenuOptions = this.getlistMenuOptions(parentMenu);
      return salesMenuOptions.some(item => this.$route.path.includes(item.path));
    },
    haveToShowCountryChange() {
      const isLoguedUser = !!this.$store.state?.currentUser;
      const isClient = this.$store.state.currentUser?.user?.rol === 'CLIENT';
      const haveToShow = isLoguedUser && !isClient && this.checkUserFeature('nav.sidebar.change-country');
      return haveToShow;
    },
    checkUserFeature(name) {
      return userFeatures.methods.checkUserFeature(name, this.$store);
    },
    allowCountryForChange(country) {
      const id = this.userIdsByCountry[country];
      return !!id;
    },
    changeCountry(newCountry) {
      const actualCountry = this.$i18n.locale;
      const newUrl = window.location.href.split(`/${actualCountry}/`)
        .join(`/${newCountry}/`);
      window.location.href = newUrl;
    },
    updateScreenWidth() {
      // Update the screenWidth property when the window is resized
      this.screenWidth = window.innerWidth;
    },
    handleClick(route) {
      this.$router.push({ name: route });
      if (window.innerWidth <= 910) {
        // Set openMenu to false to close the sidebar on mobile
        this.openMenuEmit();
      }
    },
    getlistMenuOptions(nestedOption) {
      const listMenuOptions = [];
      const { currentUser } = this.$store.state;
      if (!currentUser) {
        return [];
      }
      const { user } = currentUser;
      this.$router.options.routes[0].children.forEach(route => {
        const roles = route.meta.roles || [];
        const hasAllowedFrontRoutesNames = (user.allowedFrontRoutesNames || []).includes(route.name);
        const allowedSidebarUserFeatures = (user.allowedUserFeatures || [])
          .filter(name => name.split('.')[1] === 'sidebar')
          .map(name => name.split('.')[2])
          .includes(route.name);
        const isCheckIn = this.isCheckIn(route.name, user.checkIn);
        const pushMenuOption = (
          allowedSidebarUserFeatures
            || hasAllowedFrontRoutesNames
            || roles.includes(user.rol)
            || user.rol === Roles.ADMIN
        )
          && !(isCheckIn || route.meta.ignore);

        if (pushMenuOption) {
          listMenuOptions.push({
            name: route.meta.title,
            parentName: route.parentName,
            path: route.path,
            route: route.name,
            iconName: route.meta.iconName
          });
        }
      });
      return listMenuOptions.filter(listMenuOption => (listMenuOption.parentName === nestedOption));
    },
    openMenuEmit() {
      if (!this.openMenu) {
        this.$emit('openMenu', true);
        return;
      }
      this.$emit('openMenu', false);
    },
    async sendLogoutAction() {
      try {
        if (!(this.$store.state.currentUser && this.$store.state.currentUser.user)) {
          return;
        }
        const action = {
          country: this.$i18n.locale,
          view: this.$route.name,
          user_id: this.$store.state.currentUser.user._id,
          user_rol: this.$store.state.currentUser.user.rol,
          executed_at: new Date(),
          action: 'logout'
        };
        if (this.$store.state.currentUser.user.rol === 'INVESTOR' && this.$store.state.currentUser.user.investorsIds) {
          action.metadata = { investorsIds: this.$store.state.currentUser.user.investorsIds };
        }
        // this.$socket.emit('action', action);
      } catch (_error) {
        // console.log('Error al enviar action logout', error);
      }
    },
    async logout() {
      try {
        await this.sendLogoutAction();
      } catch (_error) {
        // console.log('Logout action event failed');
        // console.log(error);
      }
      window.location.pathname = `${this.$i18n.locale}/`;
      await authenticationService.logout();
      this.$router.push({ name: 'login' });
    },
    isCheckIn(routeName, checkIn) {
      if (!checkIn && routeName === 'check-in') return true;
      if (!checkIn) return false;
      if (checkIn.is || !checkIn.required) {
        if (routeName === 'check-in') return true;
      }
      if (!checkIn.is && checkIn.required) {
        if (routeName !== 'check-in') return true;
      }
      return false;
    },
    handledSidebar(hover) {
      this.isHovered = hover;
      this.$emit('hoverChange', this.isHovered);
    },
    toggleMenuLock() {
      this.isMenuLocked = !this.isMenuLocked;
      this.$emit('menuLock', this.isMenuLocked);
    }
  }
};
</script>
<style>
#mainSidebar.b-sidebar,
#mainSidebar.b-sidebar .sidebar-content,
#mainSidebar.b-sidebar .menu {
  transition: all 0.5s ease;
}

.trusted-id {
  text-align: center;
}

.menu-list a {
  padding: 0.35rem 0.7rem !important;
  font-family: var(--primary-font) !important;
  border-radius: 7px;
}

.menu-list li ul a {
  padding: 0.3rem 0.5rem !important;
}

#mainSidebar.b-sidebar button.button {
  transition: all 0.5s ease;
}
#mainSidebar.b-sidebar.locked button.button,
#mainSidebar.b-sidebar:not(.hide-text-on-reduce) button.button {
  margin: 5px;
}

.img-country {
  width: 15px;
  /* filter: grayscale(50%); */
}

.country {
  vertical-align: middle;
}

#menu-lock {
  background: transparent;
  font-size: 12px;
  cursor: pointer;
  border: none;
  z-index: 9999;
  transition: all 0.5s ease;
  position: fixed;
  top: 30px;
  left: 205px;
  opacity: 0;
  visibility: hidden;
}

#menu-lock:after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url('~@/ui/assets/img/sidebar-open.svg');
  background-repeat: no-repeat;
  background-size: contain;
  filter: grayscale(100%);
  opacity: 0.7;
}

#menu-lock.menu-lock-hovered {
  opacity: 0.7;
  visibility: visible;
}

#menu-lock.menu-lock-hovered:hover:after,
#menu-lock.menu-lock-hovered:focus:after {
  opacity: 1;
}

#menu-lock.active:after {
  background-image: url('~@/ui/assets/img/sidebar-close.svg');
  opacity: 0.7;
}

#menu-lock.menu-lock-hovered.active:hover:after,
#menu-lock.menu-lock-hovered.active:focus:after {
  opacity: 1;
}

@media only screen and (max-width: 1024px) {
  #mainSidebar .sidebar-content {
    max-width: 200px;
  }

  .menu-list span {
    font-family: var(--primary-font) !important;
    font-size: 0.9rem;
  }
}

@media only screen and (min-width: 911px) {

  #mainSidebar.b-sidebar {
    position: relative;
    z-index: 9999 !important;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    transition: all 0.5s ease !important;
  }

  #mainSidebar.b-sidebar .sidebar-content {
    display: block !important;
    padding: 1rem 0.75rem;
    max-width: 240px;
    border-right: 1px solid #eaeaea;
    font-family: 'Baloo Thambi 2';
  }

  #mainSidebar.b-sidebar .creditu-logo-sidebar {
    position: relative;
    padding: 0.55rem 0 1.25rem;
    transition: all 0.5s ease;
  }

  #mainSidebar:not(.locked) .sidebar-content .creditu-logo-sidebar {
    margin-left: 10px;
  }

  #mainSidebar.b-sidebar .creditu-logo-sidebar a {
    display: flex;
    align-items: center;
  }

  #mainSidebar.b-sidebar .creditu-logo-sidebar a span {
    display: inline-block;
    flex: 0 0 auto;
  }

  #mainSidebar.b-sidebar .creditu-logo-sidebar a span.iso {
    width: 34px;
    margin-right: 5px;
  }

  #mainSidebar.b-sidebar:not(.locked) .creditu-logo-sidebar a span.logo-text {
    opacity: 0;
    transition: all 0.5s ease;
  }

  #mainSidebar.b-sidebar .sidebar-content:hover .creditu-logo-sidebar a span.logo-text,
  #mainSidebar.b-sidebar .sidebar-content:focus .creditu-logo-sidebar a span.logo-text {
    opacity: 1;
  }

  #mainSidebar.b-sidebar.hide-text-on-reduce:not(.locked) .menu-list li ul {
    background: rgba(0, 0, 0, 0.06);
    border-left: none;
    margin: 0;
    padding: 5px;
    border-radius: 5px;
  }

  #mainSidebar.b-sidebar .creditu-logo-sidebar a,
  #mainSidebar.b-sidebar .menu-list li a {
    white-space: nowrap;
  }

  #mainSidebar.b-sidebar.hide-text-on-reduce:not(.locked) .menu-list li a span.icon {
    margin-right: 1rem;
    padding-left: 16px;
  }

  #mainSidebar .creditu-logo-sidebar,
  #mainSidebar.b-sidebar .menu-list li a span {
    transition: all 0.5s ease;
  }

  #mainSidebar.b-sidebar:not(.locked) .menu-list li a span:not(.icon) {
    opacity: 0;
  }

  #mainSidebar.b-sidebar .sidebar-content:hover .menu-list li a span:not(.icon) {
    opacity: 1;
  }

  #mainSidebar.b-sidebar:not(.locked) .sidebar-content:hover .menu-list a {
    text-align: left;
  }

  #mainSidebar.b-sidebar:not(.locked).hide-text-on-reduce .menu-list li ul {
    display: none;
  }

  #mainSidebar.b-sidebar .footer-selector {
    position: fixed;
    bottom: 1rem;
  }
  #mainSidebar.b-sidebar.locked .footer-selector,
  #mainSidebar.b-sidebar:not(.hide-text-on-reduce) .footer-selector {
    display: flex;
    justify-content: center;
  }

  #mainSidebar.b-sidebar.hide-text-on-reduce:not(.locked) .footer-selector span:not(.icon) {
    display: none;
  }

  #mainSidebar.b-sidebar.hide-text-on-reduce .footer-selector .button {
    margin-bottom: 5px;
  }

  #mainSidebar.b-sidebar.hide-text-on-reduce:not(.locked) .footer-selector .button .icon:first-child:not(:last-child) {
    margin-right: 0;
    margin-left: 0;
  }

}

@media only screen and (max-width: 910px) {
  #mainSidebar.b-sidebar .sidebar-content .creditu-logo-sidebar {
    height: 31px;
  }

  #mainSidebar.b-sidebar .sidebar-content {
    padding-left: 4.2%;
    padding-right: 4.2%;
  }

  #mainSidebar.b-sidebar .menu.is-custom-mobile {
    padding-top: 89px;
    height: calc(100% - 100px);
    overflow-y: auto;
  }

  .creditu-logo-sidebar img {
    display: none;
  }

  .user-info-content {
    overflow: auto;
    width: 80%;
    margin: 30px auto;
  }

  .user-info-content .user-img-content {
    float: left;
    margin: 20px 10px;
  }

  .user-info-content .text-info-content {
    float: left;
    text-align: left;
    margin-top: 18px;
    margin-left: 20px;
  }

  #mainSidebar.b-sidebar .footer-selector {
    display: flex;
    justify-content: center;

  }

  #mainSidebar.b-sidebar .footer-selector .button {
    margin: 5px;
  }
}

@media only screen and (max-width: 768px) {
}

@media only screen and (max-height: 440px) {
  .sidebar-content.is-mini {
    flex-direction: row;
  }

  #mainSidebar.b-sidebar .menu.is-custom-mobile {
    overflow-y: auto;
    height: 70%;
  }

  #mainSidebar.b-sidebar.hide-text-on-reduce .footer-selector {
    display: none;
  }

}

@media only screen and (min-width: 910px) and (max-width: 1023px) {
}

</style>
